import type { Commands, ContextRef } from "../protocol/protocol";

/** What a view shows: a context's thread, a thread by id, or the general web chat. */
export type Target =
  | { kind: "context"; ref: ContextRef }
  | { kind: "thread"; id: number }
  | { kind: "general" };

/** A target as a string, so it can key state: "context:application:12", "thread:7", "general". */
export type TargetKey = string;

export const GENERAL: Target = { kind: "general" };

export function targetKey(target: Target): TargetKey {
  if (target.kind === "context") return `context:${target.ref}`;
  if (target.kind === "thread") return `thread:${target.id}`;
  return "general";
}

export function subscribeFields(target: Target): Commands["subscribe"] {
  if (target.kind === "context") return { context_ref: target.ref };
  if (target.kind === "thread") return { thread: target.id };
  return {};
}

const CONTEXT_REF = /^([a-z][a-z_]{0,31}):([1-9][0-9]{0,18})$/;

/** The same shape the backend accepts; anything else is not a context ref. */
export function parseContextRef(
  value: unknown
): { ref: ContextRef; type: string; id: number } | null {
  const match = typeof value === "string" ? CONTEXT_REF.exec(value) : null;
  return match ? { ref: value as ContextRef, type: match[1], id: Number(match[2]) } : null;
}
